var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('DxDateBox',{attrs:{"type":"date","disabled":_vm.model.disabled,"use-mask-behavior":true,"display-format":"dd.MM.yyyy","width":_vm.getString(_vm.model.options, 'width', '200'),"value":_vm.content.value},on:{"update:value":function($event){return _vm.$set(_vm.content, "value", $event)}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }